export default __webpack_public_path__ + "static/wallpaper-45f04f2a5fbdb0165e29e9056b6e64b4.jpg";